module.exports = "    public function testIsSeatAvailable()\n    {\n        $movie = new Movie();\n        $result = $movie->isSeatAvailable(2, 2);\n        $this->assertTrue($result);\n\n        $ticket = new Ticket();\n        $ticket->setRow(2);\n        $ticket->setSeat(2);\n        $movie->addTicket($ticket);\n        $result = $movie->isSeatAvailable(2, 2);\n        $this->assertFalse($result);\n    }\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/test-movie-2.txt
// module id = 664
// module chunks = 210681221719129